import { createSelector } from '@reduxjs/toolkit';

import { TRootState } from '../index';
import { IPermissionSettingsState } from './permission-settings.slice';

/**
 A selector function to retrieve the permission settings data from the store
 @function
 @param {TRootState} state - The root state of the Redux store
 @returns {IPermissionSettingsState} The permission settings state object from the Redux store
 */
const selectPermissionSettingsState = (state: TRootState): IPermissionSettingsState => state.permissionSettings;

/**
 A memoized selector function to retrieve the permission settings state from the store
 @function
 @type {import('@reduxjs/toolkit').OutputSelector<RootState, IPermissionSettingsState, (res: IPermissionSettingsState) => IPermissionSettingsState>}
 */
export const getPermissionSettingsState = createSelector(
  [selectPermissionSettingsState],
  (state): IPermissionSettingsState => state
);
